import { TextInput } from '@mantine/core';
import { ChangeEvent } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import styles from './EntityInputs.module.scss';

import { useEntityContext } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';

const EntityNameInput = () => {
    const intl = useIntl();
    const { state, dispatch } = useEntityContext();

    const onChangeName = (evt: ChangeEvent<HTMLInputElement>) => {
        dispatch({ type: 'UPDATE_ENTITY_NAME', payload: evt.target.value });
    };

    return (
        <TextInput
            id="name"
            label={intl.formatMessage(messages.labelText)}
            placeholder={intl.formatMessage(messages.placeholder)}
            maxLength={75}
            className={styles.textInput}
            type="text"
            required
            value={state.name}
            onChange={onChangeName}
            title={intl.formatMessage(messages.title)}
            radius="md"
        />
    );
};

const messages = defineMessages({
    labelText: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.EntityNameInput.labelText',
        defaultMessage: 'Nazwa',
    },
    placeholder: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.EntityNameInput.placeholder',
        defaultMessage: 'Wprowadź nazwę swojej grupy',
    },
    title: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.EntityNameInput.title',
        defaultMessage: 'Nazwa',
    },
});

export default EntityNameInput;
